export type AnswerType =
  | 'text'
  | 'choice'
  | 'choiceText'
  | 'video'
  | 'nps'
  | 'ranked'
  | 'consent'
  | 'maxDiffSet'
  | 'slider'

export type Answer<T extends AnswerType = AnswerType> = {
  text: AnswerStructure<'text'>
  choice: AnswerStructure<'choice'>
  choiceText: AnswerStructure<'choiceText'>
  video: AnswerStructure<'video'>
  nps: AnswerStructure<'nps'>
  ranked: AnswerStructure<'ranked'>
  consent: AnswerStructure<'consent'>
  maxDiffSet: AnswerStructure<'maxDiffSet'>
  slider: AnswerStructure<'slider'>
}[T]

type AnswerStructure<T extends AnswerType> = {
  id: string
  fieldId: string
  type: T
  value: AnswerValue<T>
}

export type AnswerValue<T extends AnswerType> = {
  text: { textInput: string }
  choice: { selected: boolean }
  choiceText: { selected: boolean; textInput: string }
  video: { videoBlob: Blob | undefined }
  nps: { rating: number | undefined }
  ranked: { ranking: number }
  consent: { consent: boolean }
  maxDiffSet: { selectedForBest: boolean; selectedForWorst: boolean }
  // undefined until the respondent moves the handle. The handle still *renders* at the centre
  // from the start; display position and answered-ness are deliberately separate.
  slider: { value: number | undefined }
}[T]

export function assertAnswerType<T extends AnswerType>(
  type: AnswerType,
  expected: T,
): asserts type is T {
  if (type !== expected) throw TypeError(`Expected question type ${expected}, but recieved ${type}`)
}
